// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/scss/main.scss'
import Parallax from 'parallax-js'
import { parallax } from '@/directives/parallax.js'
import { audioHover } from '@/directives/audioHover.js'
import preventPullToRefresh from '@/mixins/preventPullToRefresh.js'
import variables from '@/variables.js'
import Vuex from 'vuex'
Vue.use(Vuex)

Vue.config.productionTip = false

Vue.directive('parallax', parallax)
Vue.directive('audioHover', audioHover)

Vue.mixin(preventPullToRefresh);

// variables.$audioFile.addEventListener('play', () => {
//   console.log('audio played')
//   variables.$paused = false
//   // variables.$pausedByClick = false
// })
// variables.$audioFile.addEventListener('pause', () => {
//   console.log('audio paused, by click? ', variables.$pausedByClick)
//   variables.$paused = true
// })

const store = new Vuex.Store({
  state: {
    mainNav: false,
    anatomy: true,
    draggerOpen: false,
    everDragged: false,
    audio: {
      file: new Audio('/static/audio.mp3'),
      paused: true,
      clicked: false,
      mobile: false
    }
  },
  mutations: {
    mainNav(state, value) {
      state.mainNav = value
    },
    anatomy(state, value) {
      state.anatomy = value
    },
    draggerOpen(state, value) {
      state.draggerOpen = value
    },
    audio(state, value) {
      state.audio = value
    },
    everDragged(state, value) {
      state.everDragged = value
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js